import * as React from "react";
const SvgFiRrLessThan = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-less-than_svg__a)">
      <path
        fill="#062147"
        d="M23.921 23.39a1 1 0 0 1-1.31.53L2.148 15.266C.842 14.71.03 13.46.03 12s.812-2.711 2.12-3.265L22.61.079a1 1 0 1 1 .78 1.842L2.93 10.577c-.663.28-.899.919-.899 1.423s.236 1.143.898 1.423l20.461 8.656a1 1 0 0 1 .531 1.31"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-less-than_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrLessThan;
